import React from 'react';

interface QuestionProgressProps {
  progress: number;
  total: number;
}

const QuestionProgress: React.FC<QuestionProgressProps> = ({ progress, total }) => {
  const pct = total > 0 ? Math.round((progress / total) * 100) : 0;
  return (
    <div className="progress-inline">
      <div className="bar">
        <div className="fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="percent-label">{pct}%</div>
    </div>
  );
};

export default QuestionProgress;
